export enum Prioridade {
  Alta = 1,
  Média = 2,
  Baixa = 3,
  Sem_Prioridade = 4
}